import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Events from '../../../events';

export default () => (
  <Switch>
    <Route path="/events" component={Events} />
  </Switch>
);
